// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"FloatingServiceButton_floatingButton__1HzrJ","pulse-ring":"FloatingServiceButton_pulse-ring__3BvUJ"};